"use client";

import { Cookie } from "lucide-react";
import { useCallback, useState, useSyncExternalStore } from "react";

const STORAGE_KEY = "arlet-cookie-consent";

function subscribe(onStoreChange: () => void) {
  window.addEventListener("storage", onStoreChange);
  return () => window.removeEventListener("storage", onStoreChange);
}

function getSnapshot() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) ?? "";
  } catch {
    return "";
  }
}

function getServerSnapshot() {
  return "decided";
}

export function CookieBar() {
  const stored = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  const [dismissed, setDismissed] = useState(false);

  const decide = useCallback((value: "all" | "essential") => {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch {
      // Soukromý režim — lištu pouze skryjeme.
    }
    setDismissed(true);
  }, []);

  if (dismissed || stored !== "") return null;

  return (
    <div className="fixed inset-x-3 bottom-3 z-[70] sm:inset-x-auto sm:right-5 sm:bottom-5 sm:max-w-md">
      <div
        role="region"
        aria-label="Nastavení cookies"
        className="glass-panel flex flex-col gap-3 rounded-2xl p-4"
      >
        <div className="flex items-start gap-3">
          <span className="inline-flex size-9 shrink-0 items-center justify-center rounded-lg bg-white/10 text-[#8fd11f]">
            <Cookie className="size-5" aria-hidden="true" />
          </span>
          <p className="text-xs leading-relaxed text-white/75">
            Používáme nezbytné cookies pro provoz webu. Souhlas s analytickými cookies
            můžete kdykoli odvolat.
          </p>
        </div>
        <div className="flex flex-col gap-2 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={() => decide("essential")}
            className="rounded-lg border border-white/20 px-4 py-2 text-xs font-medium text-white/80 transition-colors hover:border-white/40 hover:text-white"
          >
            Jen nezbytné
          </button>
          <button
            type="button"
            onClick={() => decide("all")}
            className="rounded-lg bg-green px-4 py-2 text-xs font-semibold text-white transition-colors hover:bg-green-dark"
          >
            Přijmout vše
          </button>
        </div>
      </div>
    </div>
  );
}
